import { Typography } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import Toolbar from '@mui/material/Toolbar'
import { TransitionProps } from '@mui/material/transitions'
import React from 'react'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface Props {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
  title: string
}

export const FullScreenModalComponent: React.FC<Props> = ({
  children,
  isOpen,
  onClose,
  title,
}) => (
  <Dialog
    fullScreen
    open={isOpen}
    onClose={onClose}
    TransitionComponent={Transition}
  >
    <AppBar sx={{ position: 'relative', bgcolor: 'divider' }}>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: 'primary.dark', fontWeight: 'bolder' }}
        >
          {title}
        </Typography>
        <Button variant="contained" color="error" onClick={onClose}>
          Close
        </Button>
      </Toolbar>
    </AppBar>
    {children}
  </Dialog>
)
